import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { PublicDemoShowcase } from '@/types/superadmin';

export interface SetupStatusResponse {
  setup_required: boolean;
  is_setup_required: boolean;
  signups_enabled: boolean;
  /** Only present when PUBLIC_DEMO_ENABLED is on and the showcase is seeded. */
  public_demo_enabled: boolean;
  demo: PublicDemoShowcase | null;
}

export function useSetupStatus() {
  return useQuery<SetupStatusResponse>({
    queryKey: ['auth', 'setup-status'],
    queryFn: async () => {
      try {
        const { data } = await api.get('/auth/setup-status');
        return {
          setup_required: Boolean(data.setup_required ?? data.is_setup_required),
          is_setup_required: Boolean(data.setup_required ?? data.is_setup_required),
          signups_enabled: data.signups_enabled !== undefined ? Boolean(data.signups_enabled) : true,
          public_demo_enabled: Boolean(data.public_demo_enabled),
          // Null rather than a stub, so a disabled or unseeded showcase simply
          // does not render instead of advertising a login that will not work.
          demo: (data.demo ?? null) as PublicDemoShowcase | null,
        };
      } catch {
        return {
          setup_required: false,
          is_setup_required: false,
          signups_enabled: true,
          public_demo_enabled: false,
          demo: null,
        };
      }
    },
    staleTime: 1000 * 60 * 5,
  });
}
